export default {
    NEW: 900010,
    READ: 900020
}